export default __webpack_public_path__ + "static/media/pictogramBeaconFeedback64.04b4982d.svg";